
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.9961 2.99597L26.9961 26.996L2.99609 26.996L2.99609 21.1132L16.8712 21.1132L0.000692182 4.24264L4.24333 -9.94555e-07L21.1133 16.8699L21.1133 2.99597L26.9961 2.99597Z","fill":"#CFD8E1"}})])
          )
        }
      }
    